import { defaultTo } from 'ramda';
import { IServicePackagePeriod } from '../../../repositories/billing-tariffs/entities/PublishTerms/ServicePackagePeriod';
import { EServiceType, IServicePeriod } from '../../../types/reducers/publishTerms';
import { EPublicationType } from '../../../types/reducers/publishTerms/publicationType';
import { getPeriodId } from './getPeriodId';

export function mapPeriod(period: IServicePackagePeriod): IServicePeriod {
  const { price, marketingPrice, incompatibleServices, type, token } = period;
  const periodId = getPeriodId(period);

  return {
    ...period,
    id: periodId,
    type: type as string as EPublicationType,
    price,
    marketingPrice,
    incompatibleServices: incompatibleServices as Array<string> as Array<EServiceType>,
    token: defaultTo(null, token),
  };
}
